import {Shape} from 'quickstart/components/layout/Shape'
import styled, {
  system,
  SystemProps,
  th,
} from 'quickstart/styled-components/system'

export const Wrapper = styled.div<SystemProps>`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  ${system};
`

export const Cover = styled(Shape)<SystemProps>`
  width: 100%;
  ${system};
`

export const Body = styled.div<SystemProps>`
  word-break: break-word;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  ${th('headlines.default.body')};
  ${system};
`

export const Heading = styled.div<SystemProps>`
  ${th('headlines.default.heading')};
  ${system};
`
